import { pageItemTypeByRoute } from '../../helpers/routes';

const origin = () =>
  window.location.origin ||
  `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;

export default origin;

export const getQueryParams = search => {
  const params = {};
  const query = search.replace(/^\?/, '');
  query.split('&').forEach(param => {
    const [key, value] = param.split('=');
    params[key] = value;
  });
  return params;
};

export const getUrlPageItemPaths = () => {
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  const pageIndex = pathSegments.indexOf('pages');
  if (pageIndex !== -1 && pathSegments.length > pageIndex + 2) {
    return {
      // update to change to number
      pageId: Number(pathSegments[pageIndex + 1]),
      pageItemType: pageItemTypeByRoute(pathSegments[pageIndex + 2]),
    };
  }
  return {};
};
